import {reactive, computed} from 'vue';


export default {
  name: 'CoursePageSvg',
  props: {
    width: {
      type: Number,
      required: true
    }
  },
  components: {}, 
  setup(props) {

    const state = reactive({
      width: computed(() => props.width)
    })

    return {
      state
    }
  }
}